<section id="story" class="section story">
  <div class="container story__grid">
    <div class="story__text" appReveal>
      <p class="eyebrow">Brand philosophy</p>
      <h2 class="title">A sweet <em>“little”</em>, comfortable <em>“nap”</em></h2>
      @for (p of philosophy; track $index) {
        <p class="story__para">{{ p }}</p>
      }
    </div>

    <div class="story__values">
      <h3 class="story__sub" appReveal>Core values</h3>
      <ul class="values">
        @for (v of values; track v.title; let i = $index) {
          <li class="value" [appReveal]="(i % 2) * 90">
            <span class="value__icon">
              <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">
                <path [attr.d]="v.icon" />
              </svg>
            </span>
            <span class="value__title">{{ v.title }}</span>
          </li>
        }
      </ul>
    </div>
  </div>
</section>
